import { highlightsUrlToCategory } from 'shared/helpers/eismo';
import getCategories from './getCategories';

export default categoryName => state =>
  Object.keys(getCategories(state)).find(
    categoryUrl => highlightsUrlToCategory(categoryUrl) === categoryName
  );
